import { Chip } from "@heroui/react"
import { CircleStackIcon } from "@heroicons/react/24/outline"
import { badgeStylesBySize } from "@helpers"
import PropTypes from "prop-types"

const MisCountBadge = ({ size = "md", name }) => {
  const badgeStyles = badgeStylesBySize(size)

  return (
    <Chip size={size} classNames={{ base: "w-100 max-w-none bg-cyan-400" }}>
      <span className={`flex items-center justify-center text-white px-2 font-semibold ${badgeStyles.font} `}>
        <CircleStackIcon className={`text-white mr-1  ${badgeStyles.icon}`} />
        {name}
      </span>
    </Chip>
  )
}

MisCountBadge.propTypes = {
  size: PropTypes.string,
  name: PropTypes.string.isRequired,
}

export default MisCountBadge
